import { Injectable } from '@angular/core';
import { RecommendationTracking } from './session.service';

@Injectable()
export class TrackingService {
  sunglassTypes = [
    ['008_108164_0_GrayPol85', 'farb_454_108124_0_BrownPol85', 'farb_474_108158_0_PioneerPol85'],
    [
      '008_108164_0_Gray85',
      '038_108116_0_Gray25',
      '069_108094_0_Pistachio25',
      '070_108113_0_Cinnamon25',
      '071_108121_0_Stone25',
      '072_108145_0_Jeans25',
      '091_108152_0_Rose',
      '101_108166_0_SkyletFun70',
      '102_108150_0_SkyletRoad80',
      'farb_456_brown25_flat_50',
      'farb_458_brown75_flat_50',
      'farb_459_brown90_flat_50',
      'farb_462_gray60_flat_50',
      'farb_480_blue12_flat_50',
      'Z_ECP_app_Skylet_Brown_2a',
    ],
    [
      'farb_Mirror_Blue_50',
      'farb_Mirror_Bronze_50',
      'farb_Mirror_Gold_50',
      'farb_Mirror_Green_50',
      'farb_Mirror_Red_50',
      'farb_Mirror_Silver_50',
      'farb_Mirror_StrongBlue_50',
      'farb_Mirror_White_50',
      'Z_ECP_app_mirrors_Cool_Blue_2a',
      'Z_ECP_app_mirrors_Flash_Amber_2b',
      'Z_ECP_app_mirrors_Flash_Jade_2a',
      'Z_ECP_app_mirrors_Flash_Ruby_2a',
      'Z_ECP_app_mirrors_Flash_Sapphire_2b',
    ],
  ];

  constructor() {}
  formattedSymptoms: string = '';
  formattedTypes: string = '';
  formattedActivities: string = '';
  customLens = 'Sunglasses';
  recommendationTrackingValues: RecommendationTracking[] = [];

  track(event, value) {
    console.log(event, ' ', value);

    switch (event) {
      case Event.AGE:
        this.recommendationTrackingValues.push({
          name: 'age',
          label: 'Age | ' + this.getAge(value),
          dimension: 'selected_age',
          dimensionValue: this.getAge(value)
        });
        break;
      case Event.HOURS:
        this.recommendationTrackingValues.push({
          name: 'digital-hours',
          label: 'Digital_Hours | ' + Math.round(value),
          dimension: 'selected_digital_hours',
          dimensionValue: Math.round(value)
        });
        break;
      case Event.SYMPTOM:
        this.recommendationTrackingValues.push({
          name: 'symptom',
          label: `Symptoms | ${value.length > 0 ? this.getSymptoms(value) : 'Nothing Selected'}`,
          dimension: 'selected_symptom',
          dimensionValue: value.length > 0 ? this.getSymptoms(value) : 'Nothing Selected'
        });
        break;

      case Event.ACTIVITY:
        this.recommendationTrackingValues.push({
          name: 'activity',
          label: `Activity |  ${value.length > 0 ? this.getActivities(value) : 'Nothing Selected'}`,
          dimension: 'selected_activity',
          dimensionValue: value.length > 0 ? this.getActivities(value) : 'Nothing Selected'
        });
        break;
      case Event.TYPE:
        this.recommendationTrackingValues.push({
          name: 'type',
          label: `Visual_Challenges | ${value.length > 0 ? this.getTypes(value) : 'Nothing Selected'}`,
          dimension: 'selected_type',
          dimensionValue: value.length > 0 ? this.getTypes(value) : 'Nothing Selected'
        });
        break;
      case Event.OUTDOORS:
        this.recommendationTrackingValues.push({
          name: 'percent-outdoors',
          label: `Outdoors | ${this.getPercentageOutdoors(value)}`,
          dimension: 'selected_percent_outdoors',
          dimensionValue: this.getPercentageOutdoors(value)
        });
        break;

      case Event.RECOMMENDATION:
        this.recommendationTrackingValues.push({
          name: 'recommendation',
          label: `Recommendations | ${this.getRecommendations(value)}`,
          dimension: 'selected_recommendation',
          dimensionValue: this.getRecommendations(value)
        });
        break;
    }
  }

  getAge(ageValue) {
    switch (ageValue) {
      case 45:
        return '>45';
      case 31:
        return '31-44';
      case 18:
        return '18-30';
      case 0:
        return '<18';
    }
  }

  getSymptoms(symptoms) {
    this.formattedSymptoms = '';
    symptoms.forEach((symptom, index) => {
      this.formattedSymptoms += `${symptom.name.replace('symptom_', '') + '.'} ${symptom.value}`;
      if (index != symptoms.length - 1) {
        this.formattedSymptoms += ', ';
      }
    });
    return this.formattedSymptoms;
  }

  getActivities(activities) {
    this.formattedActivities = '';
    activities.forEach((activity, index) => {
      this.formattedActivities += `${activity.name.replace('activity_', '') + '.'} ${activity.value}`;
      if (index != activities.length - 1) {
        this.formattedActivities += ', ';
      }
    });
    return this.formattedActivities;
  }

  getPercentageOutdoors(value) {
    return `${Math.round(100 - value * 100)}%`;
  }

  getTypes(types) {
    console.log('types', types);
    this.formattedTypes = '';
    types.forEach((type, index) => {
      this.formattedTypes += `${type.name.replace('type_', '') + '.'} ${type.value}`;
      if (index != types.length - 1) {
        this.formattedTypes += ', ';
      }
    });
    console.log('formattedTypes', this.formattedTypes);

    return this.formattedTypes;
  }

  getRecommendations(recommendations) {
    console.log('calling recommendations', recommendations);
    console.log('this.c', this.customLens);

    let recommendation = '';
    switch (recommendations.key) {
      case 'Eyeglasses':
        recommendation = `1. ${recommendations.value}`;
        break;

      case 'Sunglasses':
        recommendation = `2. ${recommendations.value}`;
        if (this.customLens !== 'Sunglasses') {
          console.log('this.getCustomLensType()', this.getCustomLensType());

          recommendation += `_${this.getCustomLensType()}_${this.customLens}`;
          console.log('recommendation', recommendation);
        }
        break;
    }

    return recommendation;
  }

  getCustomLensType() {
    let customized = '';
    this.sunglassTypes.forEach((element, index) => {
      if (element.indexOf(this.customLens) > -1) {
        customized = SunglassTypes[index];
      }
    });
    return customized;
  }

  resetTrackingValues() {
    this.recommendationTrackingValues = [];

    this.formattedSymptoms = '';
    this.formattedTypes = '';
    this.formattedActivities = '';
  }
}

const Event = {
  AGE: 'age',
  SYMPTOM: 'symptom',
  RECOMMENDATION: 'recommendation',
  OUTDOORS: 'percent-outdoors',
  TYPE: 'type',
  HOURS: 'digital-hours',
  ACTIVITY: 'activity',
};

const SunglassTypes = {
  0: 'P',
  1: 'T',
  2: 'M',
};



// WEBPACK FOOTER //
// ./src/services/tracking.service.ts